import 'simplebar/dist/simplebar.min.css';
import 'nprogress/nprogress.css';
import 'leaflet/dist/leaflet.css';
import './css/styles.css';
import 'devextreme/dist/css/dx.light.compact.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import fiLocale from 'date-fns/locale/fi';
import { AuthProvider } from './contexts/amplify-auth-context';
import { DepotsProvider } from './contexts/depot-context';
import { SettingsProvider } from './contexts/settings-context';
import { SessionProvider } from './contexts/session-context';
import { App } from './app';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        locale={fiLocale}
      >
        <SettingsProvider>
          <SessionProvider>
            <AuthProvider>
              <DepotsProvider>
                <App />
                <Toaster
                  position="bottom-right"
                  toastOptions={{
                    error: {
                      duration: 20000,  // 20 seconds for errors
                      style: {
                        maxWidth: '500px',
                      }
                    },
                    // Keep default duration for success toasts
                  }}
                />
              </DepotsProvider>
            </AuthProvider>
          </SessionProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </BrowserRouter>
  </HelmetProvider>
);
